import { Unlink } from 'lucide-react';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { BaseActionButton, BaseActionButtonProps } from '../BaseActionButton';

export interface UnpairDeviceButtonProps
  extends Omit<BaseActionButtonProps, 'action'> {
  deviceId: string;
  deviceName?: string;
  onUnpair: (deviceId: string) => Promise<void>;
}

export const UnpairDeviceButton: React.FC<UnpairDeviceButtonProps> = ({
  deviceId,
  deviceName,
  onUnpair,
  onSuccess,
  onError,
  confirmBeforeAction = true,
  confirmMessage,
  confirmTitle,
  children,
  ...buttonProps
}) => {
  const { t } = useTranslation();

  const handleUnpair = async () => {
    await onUnpair(deviceId);
  };

  const defaultConfirmMessage = t('device.unpair.confirmMessage', {
    deviceName: deviceName || 'Device',
    defaultValue: `Disaccoppiare il sensore "${deviceName || 'Device'}"?`,
  });

  return (
    <BaseActionButton
      action={handleUnpair}
      tooltip={t(
        'device.unpair.tooltip',
        'Disaccoppia il sensore dal dispositivo'
      )}
      confirmBeforeAction={confirmBeforeAction}
      confirmMessage={confirmMessage || defaultConfirmMessage}
      confirmTitle={
        confirmTitle ||
        t('device.unpair.confirmTitle', 'Conferma Disaccoppiamento')
      }
      onSuccess={onSuccess}
      onError={onError}
      showNotification={true}
      successNotification={{
        title: t('device.unpair.success.title', 'Sensore Disaccoppiato'),
        message: t(
          'device.unpair.success.message',
          'Il sensore è stato disaccoppiato con successo'
        ),
      }}
      errorNotification={{
        title: t('device.unpair.error.title', 'Errore Disaccoppiamento'),
        message: t(
          'device.unpair.error.message',
          'Impossibile disaccoppiare il sensore'
        ),
      }}
      leftSection={<Unlink size={16} />}
      color='orange'
      variant='light'
      size='xs'
      {...buttonProps}
    >
      {children || t('device.unpair.button', 'Disaccoppia')}
    </BaseActionButton>
  );
};
